import { combineReducers } from "redux";
import auth from "./auth";
import user from "./user";
import app from "./app";

export const rootReducers = combineReducers({
  auth,
  user,
  app,
});

export type RootState = ReturnType<typeof rootReducers>;
